var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 28.5C25.0152 28.5 28 25.5152 28 21.8333V11.1667C28 7.48477 25.0152 4.5 21.3333 4.5H10.6667C6.98477 4.5 4 7.48477 4 11.1667V21.8333C4 25.5152 6.98477 28.5 10.6667 28.5H21.3333Z",
    fill: "#2631FF",
    stroke: "#2631FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 22.5001C22.6663 20.6591 21.174 19.1667 19.333 19.1667H12.6663C10.8254 19.1667 9.33301 20.6591 9.33301 22.5001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.0003,
    cy: 12.5001,
    rx: 3.33333,
    ry: 3.33333,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.647cd070f3b5846b5b6ff7f38f470734.svg";
export { ForwardRef as ReactComponent };